import React from 'react'
import { Document, Page, Text, View, StyleSheet, Font,  Image } from '@react-pdf/renderer';
import { calcularEdad } from '../../../hooks/UseDate';
import logo from '../../../images/Logo-G-Ocho.png'

// Registro de fuente personalizada
Font.register({
    family: 'Open Sans',
    fonts: [
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
      { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
    ]
  })

  const styles = StyleSheet.create({
    page: {
      padding: 10,
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    column: {
      width: '50%',      
      fontSize: 10
    },
    bold:{
      fontFamily: 'Open Sans',
      fontWeight: 600
    },
    table: { 
      display: "table", 
      width: "auto", 
      borderStyle: "none",      
    }, 
    tableRow: {       
      flexDirection: "row" 
    }, 
    
    tableCell: { 
      width: "12.5%",
      padding: '3px',      
      fontSize: 8 
    },
    
    tableCellLarge:{
      width: "50%",
      padding: '3px',      
      fontSize: 8 
    },
    
    
    tableCellOtrosParticipantes: { 
      width: "25%",
      padding: '3px',      
      fontSize: 8 
    },
    columnMedico:{
      width: '50%',      
      fontSize: 8
    },
    textBox: {
      padding: 10,
      backgroundColor: '#e0e0e0',  // color gris
      fontSize: 9,
      marginTop: 3, // Agregar margen en la parte superior de la fila
      marginBottom: 3, // Agregar margen en la parte inferior de la fila
    },
    image: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: 60, 
      height: 60, 
      margin: '25px',
    },

    
  });

const PDFListaDeChequeo = ({dataListaChequeo,informacionEmpresa}) => {
  return (
    <Document>
        <Page size="A4" style={styles.page}>
        <Image style={styles.image} src={logo} />
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpRazSoc}</Text>   
                <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>{informacionEmpresa.EmpNit}</Text> 
        <Text style={{ fontSize: 10,textAlign: 'center',padding: '5px',fontFamily: 'Open Sans',fontWeight: 900}}>LISTA DE CHEQUEO PREPARACIÓN PREOPERATORIA DEL PACIENTE</Text> 
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, }}/>
        <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>IDENTIFICACIÓN DEL PACIENTE</Text></Text>
        <View style={styles.container}>            
            <View style={styles.column}>
                <Text><Text style={styles.bold}>Paciente:</Text> {dataListaChequeo.nombreCompleto? dataListaChequeo.nombreCompleto.trim():null}</Text>
                <Text><Text style={styles.bold}>Procedimiento a Realizar:</Text> {dataListaChequeo.procedimientoRealizar? dataListaChequeo.procedimientoRealizar.trim():null}</Text>
                <Text><Text style={styles.bold}>Nombre Cirujano:</Text> {dataListaChequeo.nombreCirujano? dataListaChequeo.nombreCirujano.trim():null}</Text>
                <Text><Text style={styles.bold}>Edad:</Text> {calcularEdad(dataListaChequeo.fechaNacimiento)} Años</Text>
                <Text><Text style={styles.bold}>Alergias:</Text> {dataListaChequeo.alergias === "0"? 'No':'Si'}</Text> 
                <Text><Text style={styles.bold}>Cuales:</Text> {dataListaChequeo.cualesAlergias}</Text>           
            </View>
            <View style={styles.column}>
                <Text><Text style={styles.bold}>Número Documento:</Text> {dataListaChequeo.numeroDocumento}</Text>
                <Text><Text style={styles.bold}>Lateralidad:</Text> {dataListaChequeo.lateralidad} </Text>
                <Text><Text style={styles.bold}>Fecha cirugía:</Text> {dataListaChequeo.fechaCirugia}</Text>
                <Text><Text style={styles.bold}>Tipo de Sangre:</Text> {dataListaChequeo.tipoSangre}</Text>                
            </View>          
        </View>
        <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>ANTECENDENTES CLINICOS</Text></Text>
        <View style={styles.container}>            
            <View style={styles.column}>
                <Text><Text style={styles.bold}>Hipertensión arterial:</Text> {dataListaChequeo.hipertensionArterial === '0'? 'No':'Si'}</Text>
                <Text><Text style={styles.bold}>Diabetes mellitus:</Text> {dataListaChequeo.diabetesMellitus === '0'? 'No': 'Si'}</Text>
                <Text><Text style={styles.bold}>R. Caída:</Text> {dataListaChequeo.caida === '0'? 'No': 'Si'}</Text>
                <Text><Text style={styles.bold}>Nombre de antibiótico profiláctico:</Text> {dataListaChequeo.antibioticoProfilactico}</Text>
                <Text><Text style={styles.bold}>Fecha y hora de ultima administración:</Text> {dataListaChequeo.fechaHoraAdministracion}</Text> 
                <Text><Text style={styles.bold}>Se corrige con:</Text> {dataListaChequeo.seCorrigeCon}</Text>           
            </View>
            <View style={styles.column}>
                <Text><Text style={styles.bold}>Se administra antihipertensivo previo a la cirugía:</Text> {dataListaChequeo.administraAntihipertensivoPrevio === '0'? 'No':'Si'}</Text>
                <Text><Text style={styles.bold}>Anti Coagulado:</Text> {dataListaChequeo.antiCoagulado === '0'? 'No':'Si'} </Text>
                <Text><Text style={styles.bold}>r.upp:</Text> {dataListaChequeo.upp === '0'? 'No': 'Si'}</Text>
                <Text><Text style={styles.bold}>Hora de administración de la profilaxis antibiótica:</Text> {dataListaChequeo.administracionProfilaxis}</Text>
                <Text><Text style={styles.bold}>Valor de la glucometria:</Text> {dataListaChequeo.glucometria}</Text>
            </View>          
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        <View  style={styles.table}>
                <View style={styles.tableRow}>
                    <View style={styles.tableCell}>
                        <Text  style={styles.bold}>N°</Text> 
                    </View>
                    <View style={styles.tableCellLarge}> 
                        <Text  style={styles.bold}>ITEM</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>OPCIÓN</Text> 
                  </View> 
                  <View style={styles.tableCell}> 
                    <Text  style={styles.bold}>OBSERVACIÓN</Text> 
                  </View>                   
                </View>
                        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >1.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Paciente presenta sintomatología respiratoria</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.sintomatologiaRespiratoria === '2'? 'N/A': (dataListaChequeo.sintomatologiaRespiratoria === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.sintomatologiaRespiratoriaTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >2.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Ayuno correcto</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.ayunoCorrecto === '2'? 'N/A': (dataListaChequeo.ayunoCorrecto === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.ayunoCorrectoTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >3.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Paciente con acceso venoso</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.accesoVeneso === '2'? 'N/A': (dataListaChequeo.accesoVeneso === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.accesoVenesoTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >4.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Paciente Adulto: catéter # 18</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.adultoCateter === '2'? 'N/A': (dataListaChequeo.adultoCateter === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.adultoCateterTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >5.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Paciente Pediátrico :catéter # 22 o 24</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.pediatricoCateter === '2'? 'N/A': (dataListaChequeo.pediatricoCateter === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.pediatricoCateterTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >6.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Eliminación del vello</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.eliminacionVello === '2'? 'N/A': (dataListaChequeo.eliminacionVello === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.eliminacionVelloTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >7.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Resultados de exámenes de laboratorio pre-quirúrgicos</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.laboratorioPreQuirurgico === '2'? 'N/A': (dataListaChequeo.laboratorioPreQuirurgico === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.laboratorioPreQuirurgicoTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >8.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Electrocardiograma presente si está indicado (patologías cardiovasculares y/o mayores de 50 años).</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.electrocardiograma === '2'? 'N/A': (dataListaChequeo.electrocardiograma === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.electrocardiogramaTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >9.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Se toma medicamentos antihipertensivos o de patologías crónicas indicados</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.medicamentosAntihipertensivosOPatologias === '2'? 'N/A': (dataListaChequeo.medicamentosAntihipertensivosOPatologias === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.medicamentosAntihipertensivosOPatologiasTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >10.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Suspensión de medicamentos ordenados por el anestesiólogo o cirujano ( medicamentos anticoagulantes, otros)</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.medicamentosAnestesiologo === '2'? 'N/A': (dataListaChequeo.medicamentosAnestesiologo === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.medicamentosAnestesiologoTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >11.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Cuenta con reserva de hemocomponentes, Consentimiento informado completamente diligenciado y firmado</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.cuentaConReserva === '2'? 'N/A': (dataListaChequeo.cuentaConReserva === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.cuentaConReservaTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >12.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Consentimiento de cirugía completo y correctamente diligenciado y firmado</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.consentimientoCirugia === '2'? 'N/A': (dataListaChequeo.consentimientoCirugia === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.consentimientoCirugiaTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >13.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Consentimiento de anestesia correctamente diligenciado y firmado</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.consentimientoAnestesia === '2'? 'N/A': (dataListaChequeo.consentimientoAnestesia === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.consentimientoAnestesiaTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >14.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Cuenta con material de osteosintesis o insumos especiales si es requerido para la cirugía</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.materialOsteosintesisOInsumos === '2'? 'N/A': (dataListaChequeo.materialOsteosintesisOInsumos === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.materialOsteosintesisOInsumosTextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >15.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Reserva de UCI si está indicado</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.reservaUCI === '2'? 'N/A': (dataListaChequeo.reservaUCI === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.reservaUCITextArea}</Text> 
                            </View>
                        </View>
                        <View style={styles.tableRow}  >
                            <View style={styles.tableCell}> 
                                <Text >16.</Text> 
                            </View> 
                            <View style={styles.tableCellLarge}> 
                                <Text >Se evidencia paciente con uñas y ojos sin maquillaje se retira prótesis dental</Text>                                 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.pacienteUnasMaquillaje === '2'? 'N/A': (dataListaChequeo.pacienteUnasMaquillaje === '0'? 'No':'Si')}</Text> 
                            </View> 
                            <View style={styles.tableCell}> 
                                <Text >{dataListaChequeo.pacienteUnasMaquillajeTextArea}</Text> 
                            </View>
                        </View>
                        
                    
        </View>
        <Text style={{borderBottomWidth: 1, borderBottomColor: 'black',  marginBottom: 5, marginTop:5}}/>
        <Text style={{fontSize: 10}}><Text style={styles.bold}>OBSERVACIONES:</Text></Text> 
        <Text style={{fontSize: 10}}>{dataListaChequeo.observaciones}</Text>
        <Text style={styles.textBox}><Text style={{ fontSize: 10,padding: '3px',fontFamily: 'Open Sans',fontWeight: 900,textAlign: 'center'}}>SIGNOS VITALES</Text></Text>
        <View style={styles.container}>            
            <View style={styles.column}>
                <Text><Text style={styles.bold}>Frecuencia Cardiaca:</Text> {dataListaChequeo.frecuenciaCardiaca}</Text>
                <Text><Text style={styles.bold}>Temperatura:</Text> {dataListaChequeo.temperatura}</Text>
                <Text><Text style={styles.bold}>Presión sistólica:</Text> {dataListaChequeo.presionSistolica}</Text>
                <Text><Text style={styles.bold}>Peso (Kg):</Text> {dataListaChequeo.peso}</Text>
            </View>
            <View style={styles.column}>
                <Text><Text style={styles.bold}>% Saturación de oxigeno:</Text> {dataListaChequeo.saturacionOxigeno}</Text>
                <Text><Text style={styles.bold}>Via Temperatura:</Text> {dataListaChequeo.viaTemperatura} </Text>
                <Text><Text style={styles.bold}>Presión diastólica:</Text> {dataListaChequeo.presionDiastolica}</Text>
                <Text><Text style={styles.bold}>Talla (cm):</Text> {dataListaChequeo.talla}</Text>
                
            </View>          
        </View>
        </Page>
    </Document>
  )
}

export default PDFListaDeChequeo